import { Textarea as BaseTextarea } from '@mantine/core';

interface TextareaProps {
  name?: string;
  placeholder?: string;
  label?: string;
  required?: boolean;
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement> | undefined;
  value?: string;
  disabled?: boolean;
}

export default function Textarea({
  name,
  label,
  required,
  placeholder,
  onChange,
  value,
  disabled,
}: TextareaProps) {
  return (
    <BaseTextarea
      name={name}
      label={label}
      required={required}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      disabled={disabled}
    />
  );
}
